import React from 'react';

import { convertStyleData } from '@utils/tools';
import { appMethod as app } from '@utils/app';

import './MapCustomComponent.less';

export default class MapCustomComponent extends React.Component {
  
  constructor(props) {
    super(props);
    this.qmap = React.createRef();
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }
  
  init = (compindex, pageInstance) => {
    let customFeature = this.props.data.customFeature;
    let markers = [{
      latitude: customFeature['lat'],
      longitude: customFeature['lng'],
      name: customFeature['address'],
      desc: customFeature['text'],
    }]
    pageInstance.setData({
      ['eles[' + compindex + '].customFeature']: {
        ...customFeature,
        markers: markers,
        markers_json_str: JSON.stringify(markers)
      }
    })
  }

  componentDidMount() {
    const customFeature = this.props.data.customFeature;
    if (customFeature.type !== 'withmap') {
      return;
    }
    // let mapInstance = new qq.maps.Map(this.qmap.current, {
    //   zoom: 13,
    //   zoomControl: false,
    //   panControl: false,
    //   mapTypeControl: false
    // });
    // if (customFeature.lat && customFeature.lng) {
    //   let latLng = new qq.maps.LatLng(customFeature.lat, customFeature.lng);
    //   this.qqMapMarker = new qq.maps.Marker({
    //     map: mapInstance,
    //     position: latLng
    //   });
    //   mapInstance.setCenter(latLng);
    // } else {
    //   mapInstance.map && mapInstance.setCenter(mapInstance.map.center);
    // }
    // mapInstance.zoomTo(13);
  }
  /**
   * 跳转地图详情
   */
  tapMapDetail = (event) => {
    event.stopPropagation();
    app.tapMapDetail(event);
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    /**
     * 返回组件
     */ 
    return (
      <div className="custom-component map" style={styleObj}
        onClick={this.tapMapDetail}
        data-event-params={data.customFeature.markers_json_str}
        >
        { customFeature.type === 'withmap' && <div ref={this.qmap} className="map-module"></div>}
        <div className="map-text">
          <span className="ico-moon icon-location"></span>
          <span className="map-link">{data.content}</span>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/map-custom-component/MapCustomComponent.jsx